import { Dispatch, Store } from 'redux'
import { RootState } from 'state'
import { Action, ActionType, ShippingType } from 'state/types/shippingType'
import { submitShippingConfirm, submitValidatePostcode } from '../apis/shippingApi'

export const createShippingConfirm = (formData: ShippingType, isSubmit: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SUBMIT_SHIPPING_PENDING
    })
    try {
      formData.customer.marketingCookieConsent = window?.Cookiebot?.consent?.marketing
      const success = isSubmit && (await submitShippingConfirm(formData))
      isSubmit &&
        dispatch({
          type: ActionType.ADD_ORDER_SUMMARY_SUCCESS,
          payload: { orderSummary: success.orderSummary }
        })
      dispatch({
        type: ActionType.SUBMIT_SHIPPING_SUCCESS,
        payload: { shippingConfirm: formData, changed: isSubmit ? true : false }
      })
      console.error('Checkout action confirmed')
    } catch (err) {
      if (err?.data?.payment?.status === 'requires_action') {
        dispatch({
          type: ActionType.REQUIRES_3D_SECURE,
          payload: { setupIntent: err?.data.payment }
        })
      } else {
        dispatch({
          type: ActionType.SUBMIT_SHIPPING_FAIL,
          payload: { errorMessage: err?.data || 'Generic error' }
        })
      }
    }
  }
}

export const saveShippingConfirmForm = (values: any, fixedOrCustomPlan: string) => {
  return function (dispatch: Dispatch<Action>, getState: Store<RootState>['getState']) {
    const { plan } = getState()
    return dispatch({
      type: ActionType.SAVE_SHIPPING_FORM,
      payload: {
        customer: {
          name: values.firstName,
          surname: values.lastName,
          email: values.email,
          marketingOptIn: values.marketingOptIn,
          telephone: values.phoneNumber,
          smsOptIn: values.smsOptIn,
          password: values.password
        },
        address: {
          shipping: {
            address1: values.shippingAddress1,
            address2: values.shippingAddress2,
            city: values.shippingCity,
            county: values.shippingCounty,
            postcode: values.shippingPostcode
          },
          billing: {
            address1: values.billingAddress1,
            address2: values.billingAddress2,
            city: values.billingCity,
            county: values.billingCounty,
            postcode: values.billingPostcode
          }
        },
        coupon: values.coupon,
        notes: values.deliveryInstructions,
        payment: values.payment,
        recipes: plan.recipesSelected,
        addons: plan.addonsSelected,
        deliveryDate: values.deliveryDate,
        plan: {
          id: `${plan.packSize}g-${plan.weeks}w`,
          type: fixedOrCustomPlan,
          level: 10,
          size: plan.planLevel,
          grams: (plan.packSize ?? 0).toString() // TODO: type fix required
        },
        fb: values.fb,
        impactRef: values.impactRef
      }
    })
  }
}

export const validatePostcode = (postcode: string, visitorId?: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.VALIDATE_POSTCODE_PENDING
    })
    try {
      const _success = await submitValidatePostcode(postcode, visitorId)
      dispatch({
        type: ActionType.VALIDATE_POSTCODE_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: ActionType.VALIDATE_POSTCODE_FAIL,
        payload: { errorMessage: err?.data }
      })
    }
  }
}

export const resetLoadingStatus = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_LOADING_STATUS
    })
  }
}

export const resetShipping = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET
    })
  }
}

export const resetErrorMessageForShipping = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_ERROR_MESSAGE
    })
  }
}
